module.exports = __webpack_public_path__ + "assets/img/icon-02.875e2e6a.png";